import type { ArticleType } from "@/lib/articles.shared";

export const ARTICLE_TYPE_LABELS: Record<"en" | "tr", Record<ArticleType, string>> = {
  en: {
    news: "News",
    blog: "Blog",
    article: "Technical article",
    whitepaper: "Whitepaper",
    "case-study": "Case study",
    trend: "Market & technology trends",
    faq: "FAQ",
  },
  tr: {
    news: "Haber",
    blog: "Blog",
    article: "Teknik makale",
    whitepaper: "Teknik rapor",
    "case-study": "Vaka analizi",
    trend: "Pazar ve teknoloji trendleri",
    faq: "SSS",
  },
};

/** German labels of the sister site — kept as data attributes for parity. */
export const ARTICLE_TYPE_LABELS_DE: Record<ArticleType, string> = {
  news: "News",
  blog: "Blog",
  article: "Fachartikel",
  whitepaper: "Whitepaper",
  "case-study": "Case Study",
  trend: "Markt- & Technologietrends",
  faq: "FAQ",
};

/**
 * Marks which kind of content the reader is looking at, matching the German
 * sister site: a leading em dash plus the type label, in both EN and TR.
 */
export function ArticleTypeBadge({
  type,
  locale,
  className = "",
}: {
  type: ArticleType;
  locale: "en" | "tr";
  className?: string;
}) {
  const label = ARTICLE_TYPE_LABELS[locale]?.[type];
  if (!label) return null;
  return (
    <span
      data-article-type={type}
      data-label-en={ARTICLE_TYPE_LABELS.en[type]}
      data-label-tr={ARTICLE_TYPE_LABELS.tr[type]}
      data-label-de={ARTICLE_TYPE_LABELS_DE[type]}
      title={`${ARTICLE_TYPE_LABELS.en[type]} · ${ARTICLE_TYPE_LABELS.tr[type]}`}
      className={`inline-block text-sm font-bold uppercase tracking-[0.12em] text-primary ${className}`.trim()}
    >
      {"— "}
      {label}
    </span>
  );
}
